var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg001(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9585 0.833328C1.78489 0.833328 0.833496 1.78472 0.833496 2.95833C0.833496 4.13193 1.78489 5.08333 2.9585 5.08333H27.0418C28.2154 5.08333 29.1668 4.13193 29.1668 2.95833C29.1668 1.78472 28.2154 0.833328 27.0418 0.833328H2.9585ZM27.7502 7.20833H2.25016V20.6667C2.25016 22.2315 3.51869 23.5 5.0835 23.5H13.9377V29.1667C13.9377 29.7535 14.4134 30.2292 15.0002 30.2292C15.587 30.2292 16.0627 29.7535 16.0627 29.1667V23.5H24.9168C26.4816 23.5 27.7502 22.2315 27.7502 20.6667V7.20833ZM21.5779 12.7135C21.8798 12.2103 21.7166 11.5576 21.2135 11.2557C20.7103 10.9538 20.0576 11.117 19.7557 11.6202L18.2225 14.1755C17.6989 15.0482 16.4656 15.1311 15.8298 14.3364C14.269 12.3853 11.2411 12.589 9.95558 14.7315L8.4224 17.2868C8.12049 17.79 8.28365 18.4427 8.78683 18.7446C9.29001 19.0465 9.94266 18.8833 10.2446 18.3801L11.7778 15.8248C12.3014 14.9521 13.5347 14.8692 14.1705 15.6639C15.7313 17.615 18.7592 17.4113 20.0447 15.2688L21.5779 12.7135Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001);
export default __webpack_public_path__ + "static/media/001.a8a043c6d78af0dfb36e2c2cb8df98aa.svg";
export { ForwardRef as ReactComponent };